/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
// import GrocedySettingTable  from './GrocedySettingTable';
import { SetProductUrlListAtom, GetProductUrlListAtom } from "../../store/productUrlAtom";
import { Link } from "react-router-dom";

import { useNavigate, useParams, useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { settingsService } from "../../services/settingsService";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";




const columns = [
  {
    title: "S/N",
    key: "Action_URL_Id",
    dataIndex: "Action_URL_Id",
    sorter: (a, b) => (a?.Action_URL_Id ?? 0) - (b?.Action_URL_Id ?? 0),
  },
  {
    title: "URL Name",
    key: "Action_URL_Name",
    dataIndex: "Action_URL_Name",
    className: "text-primary",
    sorter: (a, b) =>
      (a?.Action_URL_Name ?? "").localeCompare(b?.Action_URL_Name ?? ""),
  },
  {
    title: "Web URL",
    key: "Action_URL_Web",
    dataIndex: "Action_URL_Web",
    className: "text-primary",
    sorter: (a, b) =>
      (a?.Action_URL_Web ?? "").localeCompare(b?.Action_URL_Web ?? ""),
  },

  {
    title: "Mobile Url",
    dataIndex: "Action_URL_Mobile",
    sorter: (a, b) => (a?.Action_URL_Mobile ?? 0) - (b?.Action_URL_Mobile ?? 0),
  },
  {
    title: "Status",
    dataIndex: "Feature_Action_Status_Name",
    sorter: (a, b) =>
      (a?.Feature_Action_Status_Name ?? "").localeCompare(b?.Feature_Action_Status_Name ?? ""),

  },
];



const ProductionActionUrlMainPage = () => {
    const getProductUrlList = GetProductUrlListAtom();
    const setProductUrlList = SetProductUrlListAtom();
    const navigate = useNavigate();
    const { pathname } = useLocation();  
    var url = pathname.split('/')
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];


  useEffect(() => {
    window.title = "Product Action Url"
    if (getProductUrlList.length < 1) {
      // loadDataFromServer();
    }
  }, [getProductUrlList.length]);



  const loadDataFromServer = () => {
    settingsService.productActionURList().then(res => {
      if (res?.data?.length) {
        setProductUrlList(res.data);
      }
    });
  }



  const addNewMenu = () => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }


  function handleRowClick(product) {
    const id = product['Action_URL_Id'];
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`);
  }



  return (
    <>
      <div className=" b">
        <div className="text-center p-2 font-bold h5" >PRODUCT ACTION URL</div>
        <section className="">




          <div className="flex justify-between w-full  "  >
            <Tooltip title="Reload">
              <RestartAlt
                className="cursor ml-2 mt-1"
                onClick={() => loadDataFromServer()}
                color="primary"
                fontSize="large"
              />
            </Tooltip>
            <button
              onClick={() => addNewMenu()}
              style={{ backgroundColor: "#476EF8" }}
              className="  rounded text-white text-sm font-[Poppins] mt-1 py-2  px-3"
            >
              Add New
            </button>
          </div>

                <GeneralCustomTable
                  tableHeadList={columns}
                  tableDataList={getProductUrlList}
                  allowCheckBox={false}
                  rowKey={(record) => record.Ref_No}
                  handleRowClick={handleRowClick}
                />
        </section>
      </div>


    </>
  );
}

 
export default ProductionActionUrlMainPage;
